import { BaseReq, PaginationReq, PaginationResp, UpdaterResp,FileRecord } from "@/core/interface";
import { QuantityRecord } from "./form/quantity-table/quantity-table.interface";
import { MaterialRecord } from "./form/material-table/material-table.interface";
export enum TeamTypeEnum {
  BIZ_MAN = 1, // 业务员
  CUSTOMER_MANAGER = 2, // 客户经理
  TENDER_OWNER = 3, // 投标负责人
  DESIGN_OWNER = 4, // 设计负责人
  PROJECT_MANAGER = 5, // 项目经理
}

export enum FlowStatusEnum {
  DTJ = "dtj", // 待提交
  SPZ = "spz", // 审批中
  SPTG = "sptg", // 审批通过
  SPBTG = "spbtg", // 审批不通过
}
/**
 * 计价方式枚举
 */
export enum PriceMannerEnum {
  ZJHT = "zjht", // 总价合同
  DJHT = "djht", // 单价合同
}
/**
 * Tab 枚举
 */
 export enum ContractTabEnum {
  BASIC_TAB = "BASIC_TAB", // 基本信息
  QUANTITY_TAB = "QUANTITY_TAB", // 工程量清单
  MATERIAL_TAB = "MATERIAL_TAB", // 材料清单
  ATTACHMENT_TAB = "ATTACHMENT_TAB", // 附件
  FLOW_TAB = "FLOW_TAB", // 流程
}
export class ProfileReq extends BaseReq {
  name: string = ""; // 合同名称
  projectId: string = ''; // 项目ID
  externalNo: string=""; // 外部合同编号
  performProvinceId: number | string=''; // 	履约地省份 ID
  performCityId: number | string=''; // 履约地市 ID
  performDistrictId: number | string=''; // 履约地区域 ID
  performAddress: string = ""; // 履约地详细地址
  rangeRemark: string = ""; // 分包范围
  receiptAgreement: string = ""; // 收款协议
  mainAgreement: string="";// 主要条款
  remark: string=""; // 备注
  supplierBCooperationCompanyId: number|undefined=undefined; // 供应商ID
  subcontractType: string | undefined = undefined; // 合同类型
  subcontractAttribute: string | undefined = undefined; // 分包属性
  signDate: string|undefined=undefined; // 合同签订日期
  startDate: string|undefined=undefined; // 开始日期
  endDate: string|undefined=undefined; // 结束日期
  contractPricingManner: string =""; // 计价方式
  // contractPricingManner: string = PriceMannerEnum.ZJHT; // 计价方式
  signAmount: number|undefined=undefined ; // 合同签订金额
  advancePayment: number|undefined=undefined;// 预付款
  performMoney: number|undefined=undefined; // 履约保证金
  qualityMoney: number|undefined=undefined; // 质保金
  maintainTime: string = "year"; // 维保期限
  maintainVal:number=0;// 维保期限值
  boperatorName: string=""; // 乙方经办人
  fileList: FileRecord[] = []; //附件
  boperatorTenantUserId: number|undefined=undefined; // 甲方经办人
  id:string='';//合同ID
  quantitiesList: QuantityRecord[] = [];
  materialList: MaterialRecord[] = [];
  //额外添加工程量的数据类型
  // quantitiesAReqs:QuantityRecord[] = [];//工程量
}

export class ProfilePageReq extends PaginationReq {
  projectName: string | undefined = undefined; // 项目名称
  subcontractStatus: string | undefined = undefined; // 合同状态
  settleStatus: string | undefined = undefined; // 结算状态
  supplierBCooperationCompanyId: number | undefined = undefined; // 供应商ID
  bOperatorTenantUserId:number|undefined=undefined;//经办人ID
  signsStartDate:string|undefined=undefined;//签订开始日期
  signEndDate:string|undefined=undefined;//签订结束日期
  status:string='';
}

export class ProfileListRecord extends UpdaterResp {
  id: number = 0; // 项目ID
  bizNo: string = ""; // 项目编号
  name: string = ""; // 项目名称
  cooperationCompanyId: string = "";
  companyName: string = "";
  projectTypeId: string = "";
  projectTypeName: string = "";
  provinceId: number = 0;
  provinceName: string = "";
  cityId: number = 0;
  cityName: string = "";
  districtId: number = 0;
  districtName: string = "";
  stage: string = "";
  stageName: string = "";
  status: string = "";
  statusName: string = "";
  flowStatus: string = "";
  flowStatusName: string = "";
  salesmanTenantUserId: number = 0;
  salesmanTenantUserName: string = "";
}

export class ProfilePageResp extends PaginationResp<ProfileListRecord> {}

export class ProfileSimpleListReq extends BaseReq {
  otherStatus: string[] = [];
  projectStatus: string | undefined = undefined;
  flowStatus: string | undefined = undefined;
}

class ProfileSimpleRecord {
  id: number = 0;
  name: string = "";
}

export class ProfileSimpleListResp {
  records: ProfileSimpleRecord[] = [];
}

class Team {
  type: TeamTypeEnum;
  tenantUserId: string = "";
  realName: string = "";
}

class Customer {
  cooperationCompanyId: string = "";
  companyName: string = "";
  contacts: string = "";
  mobile: string = "";
}

export class Cooperation {
  id: string = "";
  cooperationCompanyId: string = "";
  companyName: string = "";
}

export class ProfileDetailResp extends UpdaterResp {
  advancePayment: number; // 预付款
  alreadySettledAmount: number; // 累计已结算金额
  bizNo: string = ""; //
  boperatorName: string = ""; //
  boperatorTenantUserId: number; //
  boperatorTenantUserName: string = ""; //
  contractPricingManner: string = ""; // 计价方式字典值
  contractPricingMannerName: string = ""; // 计价方式
  externalNo: string = ""; // 外部合同编号
  flowStatus: string = ""; // 审批状态字典值
  flowStatusName: string = ""; // 审批状态
  mainAgreement: string = ""; // 主要条款
  maintainTime: string = ""; // 维保期限字典值
  maintainTimeName: string = ""; // 维保期限
  maintainVal: string = ""; // 维保期限值
  name: string = ""; // 履约详细地址
  performCityId: number; // 履约市ID
  performCityName:string="";// 履约市名称
  performDistrictId: string=""; // 履约区域ID
  performDistrictName: string=""; // 履约区域名称
  performProvinceId:number;//履约省份ID
  performProvinceName:string="";//履约省份名称
  performMoney: number = 0; // 履约保证金
  projectId: number; // 项目ID
  projectName: string = ""; // 项目名称
  qualityMoney: number; // 质保金
  rangeRemark: string = ""; // 分包范围
  receiptAgreement: string = ""; // 收款协议
  remark: string = ""; // 备注
  settleStatus: string=""; // 结算状态字典值
  settleStatusName: ""; // 结算状态
  signDate:string="";//签订日期
  startDate:string="";//开始日期
  endDate: string = ""; // 结束日期
  subcontractAttribute:string="";//分包属性字典值
  subcontractAttributeName:string="";//分包属性名称
  subcontractStatus:string="";//合同状态字典值
  subcontractStatusName:string="";//合同状态
  subcontractType:string="";//分包合同类型字典值
  subcontractTypeName:string="";//分包合同类型名称
  supplierBCooperationCompanyId:number;//乙方供应商ID
  supplierBCooperationCompanyName:string="";//乙方供应商名称
  tenantId:number;//租户ID
  tenantName:string="";//租户名称
  id:string;//合同ID
}

export class ProfileSwitchFlowStatusReq extends BaseReq {
  flowStatus: FlowStatusEnum = FlowStatusEnum.DTJ;
}
